var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_373_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.707031 6.49967C0.707031 6.49967 3.54036 0.833008 8.4987 0.833008C13.457 0.833008 16.2904 6.49967 16.2904 6.49967C16.2904 6.49967 13.457 12.1663 8.4987 12.1663C3.54036 12.1663 0.707031 6.49967 0.707031 6.49967Z",
    stroke: "#050409",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.625C9.6736 8.625 10.625 7.6736 10.625 6.5C10.625 5.32639 9.6736 4.375 8.5 4.375C7.32639 4.375 6.375 5.32639 6.375 6.5C6.375 7.6736 7.32639 8.625 8.5 8.625Z",
    stroke: "#050409",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye4);
export default __webpack_public_path__ + "static/media/eye 4.27748ec46569b8272b76c38aa37c2822.svg";
export { ForwardRef as ReactComponent };